import { json, jsonParseLinter } from '@codemirror/lang-json'
import { linter, lintGutter } from '@codemirror/lint'
import { Accordion, AccordionDetails, AccordionSummary, Box, Card, CardContent, CardHeader, Typography } from '@mui/material'
import CodeMirror from '@uiw/react-codemirror'
import { IFlow } from '../../definitions/Nodes'
import Helper from '../../helpers/Helper'
import FlowExecutionManager from '../../managers/FlowExecutionManager'
import { useAppSelector } from '../../store/Hooks'

interface Props {
    flow: IFlow
}

const ExecuteStatusModal = ({ flow }: Props) => {
    const execEnv = FlowExecutionManager.execEnv
    const mode = useAppSelector(state => state.app.mode)

    return (
        <Box margin='80px auto auto' maxWidth='80vw'>
            <Card>
                <CardHeader title='Run Status' />
                <CardContent style={{ maxHeight: '75vh', overflowY: 'auto', gap: 10 }}>
                    {flow.nodes.map(x => {
                        const memory = execEnv?.memories.find(k => k?.node?.uuid === x.uuid)
                        return (
                            <Box key={x.uuid} marginTop={2}>
                                <Typography>Node: {x.name}</Typography>
                                <Typography>Status: {memory?.status ?? 'unknown'}</Typography>
                            </Box>
                        )
                    })}
                    <Typography>...</Typography>
                    {Helper.isDev() && (
                        <>
                            <Typography marginTop={10}>DEV</Typography>
                            <Accordion>
                                <AccordionSummary
                                    aria-controls='panel1-content'
                                    id='panel1-header'>
                                    <Typography>Execution Environment</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box sx={{ height: 500, overflowY: 'auto' }}>
                                        <CodeMirror
                                            theme={mode === 'dark' ? 'dark' : 'light'}
                                            style={{ color: 'red', colorScheme: 'dark', flex: 1, height: '100%', display: 'flex', overflow: 'auto' }}
                                            value={JSON.stringify((execEnv ?? {}), null, 4)}
                                            width='100%'
                                            readOnly
                                            minHeight='30vh'
                                            extensions={[json(), lintGutter(), linter(jsonParseLinter())]}
                                        />
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        </>
                    )}
                </CardContent>
            </Card>
        </Box>
    )
}

export default ExecuteStatusModal
